import 'css-chunksrc/client/scenes/resourceEdition/assignCalendarHolidaysToResource/styles.scss';export default {
  "calendarHolidaysContainer": "_calendarHolidaysContainer_1921y_1",
  "calendarHolidaysGroup": "_calendarHolidaysGroup_1921y_6",
  "calendarHolidaysWrapper": "_calendarHolidaysWrapper_1921y_10",
  "activityReport": "_activityReport_1921y_16",
  "title": "_title_1921y_21"
};